module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', {
    ref: "screenLayout"
  }, [_c('template', {
    slot: "header"
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "flat": "",
      "dark": "",
      "dense": "",
      "xxstyle": "z-index:8;position:fixed;"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Taco")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('ToolbarSearch', {
    ref: "searchBox",
    attrs: {
      "debounced": ""
    },
    on: {
      "search": _vm.search
    }
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.makeContacts
    }
  }, [_c('v-list-item-title', [_vm._v("Make 100 Contacts")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.makeGroups
    }
  }, [_c('v-list-item-title', [_vm._v("Make Initial Groups")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.createInitialTeams
    }
  }, [_c('v-list-item-title', [_vm._v("Make Initial Teams For This User")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.initSearchFields
    }
  }, [_c('v-list-item-title', [_vm._v("Initialise Search Fields")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "left"
  }, [_c('div', {
    staticStyle: {
      "background-color": "#e0e0e0",
      "height": "100%"
    }
  }, [_c('DataLoader', {
    ref: "groupsData",
    attrs: {
      "collection": "groups",
      "sort-field": "name",
      "limit": 40
    },
    on: {
      "loaded": _vm.groupsLoaded
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var groups = ref.items;

        return [_c('OneOrMoreList', {
          ref: "groupsList",
          attrs: {
            "items": groups,
            "icon": "mdi-account-group"
          },
          on: {
            "add": _vm.addGroup,
            "expanded": _vm.groupExpanded,
            "contracted": _vm.groupContracted,
            "selection-change": function($event) {
              return _vm.resetContactSelection(false)
            }
          },
          scopedSlots: _vm._u([{
            key: "selection",
            fn: function() {
              return [_c('div', {
                staticClass: "ml-3 mr-3"
              }, [_c('div', {
                staticClass: "element-label"
              }, [_vm._v("Show contacts that are in")]), _vm._v(" "), _c('v-btn-toggle', {
                attrs: {
                  "borderless": "",
                  "dense": ""
                },
                model: {
                  value: (_vm.joinSets),
                  callback: function($$v) {
                    _vm.joinSets = $$v
                  },
                  expression: "joinSets"
                }
              }, [_c('v-btn', {
                attrs: {
                  "value": "intersection"
                }
              }, [_c('span', {
                staticClass: "hidden-sm-and-down"
              }, [_vm._v("All Groups")]), _vm._v(" "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-vector-intersection")])], 1), _vm._v(" "), _c('v-btn', {
                attrs: {
                  "value": "union"
                }
              }, [_c('span', {
                staticClass: "hidden-sm-and-down"
              }, [_vm._v("Any Group")]), _vm._v(" "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-vector-arrange-below")])], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
                on: {
                  "click": function($event) {}
                }
              }, [_c('v-list-item-title', [_vm._v("Do Something")])], 1)]
            },
            proxy: true
          }, {
            key: "title",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', {
                staticClass: "swatch-container"
              }, [_c('v-chip', {
                staticStyle: {
                  "margin": "0px 5px 0 -3px",
                  "width": "44px",
                  "text-align": "center"
                },
                attrs: {
                  "dark": "",
                  "small": "",
                  "color": item.colour || '#ccc'
                }
              }, [_vm._v(_vm._s(item.members || '0'))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.name))])], 1)]
            }
          }, {
            key: "content",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', {
                staticClass: "pa-2"
              }, [_c('v-form', [_c('v-text-field', {
                ref: "name",
                attrs: {
                  "label": "Name",
                  "hide-details": ""
                },
                model: {
                  value: (item.name),
                  callback: function($$v) {
                    _vm.$set(item, "name", $$v)
                  },
                  expression: "item.name"
                }
              }), _vm._v(" "), _c('v-switch', {
                attrs: {
                  "color": "blue",
                  "label": "Favourite",
                  "hide-details": ""
                },
                model: {
                  value: (item.favourite),
                  callback: function($$v) {
                    _vm.$set(item, "favourite", $$v)
                  },
                  expression: "item.favourite"
                }
              }), _vm._v(" "), _c('ColourBar', {
                staticClass: "mt-2",
                attrs: {
                  "colours": _vm.colours,
                  "label": "Colour"
                },
                model: {
                  value: (item.colour),
                  callback: function($$v) {
                    _vm.$set(item, "colour", $$v)
                  },
                  expression: "item.colour"
                }
              })], 1), _vm._v(" "), _c('div', {
                staticClass: "element-label mt-4"
              }, [_vm._v("Actions")]), _vm._v(" "), _c('div', {
                staticClass: "action-menu"
              }, [_vm._v("Email Group")]), _vm._v(" "), _c('div', {
                staticClass: "action-menu"
              }, [_vm._v("Delete Group")]), _vm._v(" "), (_vm.selectedContacts.length > 0) ? _c('div', {
                staticClass: "action-menu",
                on: {
                  "click": function($event) {
                    return _vm.addToGroup(item)
                  }
                }
              }, [_vm._v("Add Selected Contacts")]) : _vm._e()], 1)]
            }
          }], null, true)
        })]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "pa-2"
  }, [_c('v-btn', {
    staticClass: "full-width grey--text text--darken-1",
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "color": "grey lighten-2",
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": _vm.addGroup
    }
  }, [_vm._v("Add a Group")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pa-3 elevation-1 ma-3",
    staticStyle: {
      "overflow": "auto",
      "background-color": "#f0f0f0"
    }
  }, [_c('DataLoader', {
    ref: "contactsData",
    attrs: {
      "collection": "contacts",
      "search": _vm.contactSearch,
      "conditions": _vm.groupsFilter,
      "sort-field": _vm.sortField,
      "limit": 40
    },
    on: {
      "loading": _vm.contactsLoading,
      "loaded": _vm.contactsLoaded
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var contacts = ref.items;

        return [_c('OneOrMoreList', {
          ref: "contactsList",
          attrs: {
            "lock": Boolean(_vm.lock || _vm.addingRelationship),
            "hide-expander": "",
            "width": "350px",
            "items": contacts,
            "icon": "mdi-account-user"
          },
          on: {
            "selection-change": _vm.contactSelectionChanged
          },
          scopedSlots: _vm._u([{
            key: "selection",
            fn: function() {
              return [_c('v-list-item', {
                on: {
                  "click": function($event) {}
                }
              }, [_c('v-list-item-title', [_vm._v("Do Something")])], 1)]
            },
            proxy: true
          }, {
            key: "title",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', {
                staticClass: "swatch-container"
              }, [_c('img', {
                staticClass: "contact-image mr-2",
                attrs: {
                  "src": item.image,
                  "alt": ""
                },
                on: {
                  "click": function($event) {
                    return _vm.avatarClicked(item)
                  }
                }
              }), _vm._v(" "), _c('div', {
                staticClass: "contact-details"
              }, [_c('div', [_vm._v("\n                                    " + _vm._s(item.firstName) + " " + _vm._s(item.lastName) + " "), (item.hasPartner) ? _c('span', {
                staticStyle: {
                  "font-weight": "300"
                }
              }, [_vm._v(" +")]) : _vm._e()]), _vm._v(" "), _c('div', {
                staticStyle: {
                  "font-weight": "300"
                }
              }, [_vm._v("\n                                    " + _vm._s(item.mobile) + " \n                                ")]), _vm._v(" "), _c('div', {
                staticClass: "small-text",
                staticStyle: {
                  "font-weight": "300"
                }
              }, [_vm._v("\n                                    " + _vm._s(_vm.getItemTeamName(item)) + " \n                                ")])]), _vm._v(" "), _c('v-btn', {
                staticStyle: {
                  "margin-top": "-3px"
                },
                attrs: {
                  "icon": "",
                  "color": "grey lighten-1"
                },
                on: {
                  "click": function($event) {
                    $event.stopPropagation();
                    return _vm.sendEmail(item)
                  },
                  "mousedown": function($event) {
                    $event.stopPropagation();
                  }
                }
              }, [_c('v-icon', [_vm._v("email")])], 1)], 1)]
            }
          }], null, true)
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "right"
  }, [_c('div', {
    staticClass: "pa-3"
  }, [(_vm.lock) ? _c('div', {
    key: "lock",
    staticClass: "panel-multi pa-3 mb-3 rounded display-flex",
    staticStyle: {
      "border": "dotted 4px #2E9AFE",
      "background-color": "white"
    }
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lock) + "\n            ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue",
      "small": "",
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.resetContactSelection(true)
      }
    }
  }, [_vm._v("Clear")])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedContacts.length > 0) ? _c('div', {
    key: "base",
    staticClass: "panel-multi white pa-3 rounded",
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.lock) ? _c('v-btn', {
    staticStyle: {
      "position": "absolute",
      "top": "5px",
      "right": "5px",
      "z-index": "100"
    },
    attrs: {
      "color": (_vm.lock ? 'blue' : 'grey lighten-2'),
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.lock = 'Selection is locked on'
      }
    }
  }, [_c('v-icon', [_vm._v("lock")])], 1) : _vm._e(), _vm._v(" "), _c('ContactImages', {
    attrs: {
      "contacts": _vm.selectedContacts,
      "partners": _vm.contactsArePartners
    }
  }), _vm._v(" "), (_vm.selectedContacts.length == 1) ? _c('div', [_c('div', {
    key: "one"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "10",
      "flex-basis": "200px"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "First Name",
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedContact.firstName),
      callback: function($$v) {
        _vm.$set(_vm.selectedContact, "firstName", $$v)
      },
      expression: "selectedContact.firstName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Last Name",
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedContact.lastName),
      callback: function($$v) {
        _vm.$set(_vm.selectedContact, "lastName", $$v)
      },
      expression: "selectedContact.lastName"
    }
  })], 1)]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email",
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedContact.email),
      callback: function($$v) {
        _vm.$set(_vm.selectedContact, "email", $$v)
      },
      expression: "selectedContact.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Mobile",
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedContact.mobile),
      callback: function($$v) {
        _vm.$set(_vm.selectedContact, "mobile", $$v)
      },
      expression: "selectedContact.mobile"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.selectedContacts.length == 2) ? _c('div', {
    key: "two",
    staticClass: "white pa-3 rounded panel-multi"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-content": "center",
      "font-size": "12px",
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1",
      "text-align": "center"
    }
  }, [(_vm.addingRelationship) ? _c('v-select', {
    staticStyle: {
      "width": "110px",
      "margin": "0 auto"
    },
    attrs: {
      "items": _vm.relationshipNames,
      "return-object": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.newRelationship),
      callback: function($$v) {
        _vm.newRelationship = $$v
      },
      expression: "newRelationship"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1",
      "text-align": "center"
    }
  }, [(_vm.addingRelationship) ? _c('v-text-field', {
    staticStyle: {
      "width": "110px",
      "margin": "0 auto"
    },
    attrs: {
      "value": _vm.newRelationship.relatedText,
      "hide-details": ""
    },
    on: {
      "keydown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "stretch-contents mt-3"
  }, [(_vm.addingRelationship) ? [_c('v-btn', {
    attrs: {
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": _vm.saveRelationship
    }
  }, [_vm._v("\n                            Save Relationship\n                        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.addingRelationship = false
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])] : _vm._e(), _vm._v(" "), (!_vm.addingRelationship) ? [(_vm.contactsArePartners) ? _c('v-btn', {
    attrs: {
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": _vm.separatePartners
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "color": "grey"
    }
  }, [_vm._v("mdi-heart-broken")]), _vm._v("\n                            Separate\n                        ")], 1) : _vm._e(), _vm._v(" "), (_vm.contactsCouldBePartners) ? _c('v-btn', {
    attrs: {
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": _vm.makePartners
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "color": "grey"
    }
  }, [_vm._v("mdi-heart")]), _vm._v("\n                            Make Partners\n                        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.contactsArePartners && !_vm.contactsCouldBePartners && !_vm.differentTeams) ? _c('div', {
    staticClass: "small-text light-text center-text"
  }, [_vm._v("\n                            Contacts have existing partner/s\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.differentTeams) ? _c('div', {
    staticClass: "small-text light-text center-text"
  }, [_vm._v("\n                            Contacts have different teams\n                        ")]) : _vm._e(), _vm._v(" "), (!_vm.differentTeams) ? _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.addingRelationship = true
      }
    }
  }, [_vm._v("\n                            Relate Contacts\n                        ")]) : _vm._e()] : _vm._e()], 2)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.selectedContacts.length == 0) ? _c('div', {
    staticClass: "white pa-3 rounded mt-0"
  }, [_c('div', {
    staticClass: "element-label mb-2"
  }, [_vm._v("Sorted by " + _vm._s(_vm.sortField))]), _vm._v(" "), _c('v-btn', {
    staticClass: "full-width",
    attrs: {
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.sortField = _vm.alternateSortField
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-sort")]), _vm._v("\n                    Sort by " + _vm._s(_vm.alternateSortField) + "\n                ")], 1)], 1) : _vm._e(), _vm._v(" "), (this.selectedContacts.length > 0) ? _c('div', {
    staticClass: "white pa-3 rounded mt-4"
  }, [_c('div', {
    staticClass: "element-label"
  }, [_vm._v("Groups")]), _vm._v(" "), (this.selectedContacts.length == 1) ? _c('TagsView', {
    attrs: {
      "tags": _vm.selectedContact.tags,
      "available-tags": this.groups
    },
    on: {
      "remove": _vm.removeFromGroup
    }
  }) : _vm._e(), _vm._v(" "), _c('GroupDropdown', {
    staticClass: "full-width",
    attrs: {
      "buttonClass": "mt-2",
      "groups": _vm.groups,
      "label": "Add to Group"
    },
    on: {
      "new": _vm.addToNewGroup,
      "select": _vm.addToGroup
    }
  }), _vm._v(" "), (this.selectedContacts.length != 1) ? _c('GroupDropdown', {
    staticClass: "full-width",
    attrs: {
      "buttonClass": "mt-2",
      "groups": _vm.groups,
      "label": "Remove from Group",
      "existing-only": ""
    },
    on: {
      "select": _vm.removeFromGroup
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.selectedContacts.length == 1) ? _c('div', {
    key: "relationships",
    staticClass: "white pa-3 rounded mt-4"
  }, [_c('div', {
    staticClass: "element-label"
  }, [_vm._v("Relationships")]), _vm._v(" "), _c('DataLoader', {
    attrs: {
      "collection": "relationships",
      "conditions": _vm.relationshipsFilter,
      "limit": 10
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var relationships = ref.items;

        return [_vm._l((relationships), function(relationship) {
          return [_c('v-menu', {
            key: relationship._id,
            attrs: {
              "offset-y": "",
              "left": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({
                  key: relationship._id,
                  staticClass: "hoverable clickable",
                  staticStyle: {
                    "display": "flex",
                    "padding": "4px"
                  }
                }, on), [_c('img', {
                  staticClass: "contact-image white-border shadow",
                  staticStyle: {
                    "height": "40px",
                    "width": "40px",
                    "margin-right": "20px"
                  },
                  attrs: {
                    "alt": "",
                    "src": relationship.relatedImage
                  }
                }), _vm._v(" "), _c('div', {
                  staticStyle: {
                    "flex-grow": "1",
                    "font-size": "14px"
                  }
                }, [_c('div', [_vm._v("\n                                        " + _vm._s(relationship.relatedFirstName) + " " + _vm._s(relationship.relatedLastName) + "\n                                    ")]), _vm._v(" "), _c('div', {
                  staticStyle: {
                    "font-weight": "300"
                  }
                }, [_vm._v("\n                                        " + _vm._s(relationship.relatedRelationship) + "\n                                    ")])])])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
            on: {
              "click": function($event) {
                return _vm.goToRelated(relationship)
              }
            }
          }, [_c('v-list-item-title', [_vm._v("Go to " + _vm._s(relationship.relatedFirstName))])], 1), _vm._v(" "), _c('v-list-item', {
            on: {
              "click": function($event) {
                return _vm.removeRelationship(relationship)
              }
            }
          }, [_c('v-list-item-title', [_vm._v("Remove this relationship")])], 1)], 1)], 1)]
        })]
      }
    }, {
      key: "empty",
      fn: function() {
        return [_c('div', {
          staticStyle: {
            "display": "flex",
            "align-items": "center"
          }
        }, [_c('div', {
          staticStyle: {
            "font-size": "24px",
            "padding": "3px 3px 0 3px"
          }
        }, [_vm._v("🤔")]), _vm._v(" "), _c('div', {
          staticClass: "light-text",
          staticStyle: {
            "font-size": "14px"
          }
        }, [_vm._v("Totally unrelated")])])]
      },
      proxy: true
    }], null, false, 2260953761),
    model: {
      value: (_vm.singleRelationships),
      callback: function($$v) {
        _vm.singleRelationships = $$v
      },
      expression: "singleRelationships"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": _vm.addRelationshipToIndividual
    }
  }, [_vm._v("Add Relationship")])], 1) : _vm._e(), _vm._v(" "), (this.selectedContacts.length > 0) ? _c('div', {
    key: "groups",
    staticClass: "white pa-3 rounded mt-4"
  }, [_c('div', {
    staticClass: "element-label"
  }, [_vm._v("Download to Excel")]), _vm._v(" "), _c('VueJsonToCsv', {
    attrs: {
      "jsonData": _vm.downloadableContacts,
      "labels": _vm.downloadableLabels(_vm.downloadableContacts)
    },
    on: {
      "success": _vm.downloadComplete
    }
  }, [_c('v-btn', {
    staticClass: "full-width",
    attrs: {
      "depressed": "",
      "rounded": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey lighten-1",
      "left": ""
    }
  }, [_vm._v("mdi-cloud-download")]), _vm._v("\n                    Download\n                ")], 1)], 1)], 1) : _vm._e()])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6064625a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/GridScreen.vue
// module id = 2578
// module chunks = 1